export default "__VITE_ASSET__BUcydGlW__"